export const columns = [
  {
    accessorKey: "name",
    header: "Agent Name",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "challanNumber",
    header: "Challan Number",
    type: "number",
    flex: 1,
  },
  {
    accessorKey: "cnic",
    header: "CNIC",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "phoneNumber",
    header: "Phone Number",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "repName",
    header: "Agent Rep Name",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "createdBy",
    header: "Created By",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
